import { atom, useRecoilState } from 'recoil';
import { Assets, Texture } from 'pixi.js';

import { textures } from '@/constants';
import { gemAssets, GemType } from '@/framework/gem';

const loaderState = atom({
  key: 'loaderState',
  default: false,
});

function buildAssetList(): { alias: string; src: string }[] {
  const assets: { alias: string; src: string }[] = [];

  (Object.keys(textures) as (keyof typeof textures)[]).forEach((key) => {
    assets.push({ alias: key, src: textures[key] });
  });

  (Object.keys(gemAssets) as GemType[]).forEach((gemKey) => {
    assets.push({
      alias: `gem-${gemKey}`,
      src: gemAssets[gemKey]['default']['2x'].src,
    });
  });

  return assets;
}

let loadPromise: Promise<void> | null = null;

function loadAllAssets(): Promise<void> {
  if (!loadPromise) {
    loadPromise = (async () => {
      const assets = buildAssetList();
      Assets.add(assets);
      await Assets.load(assets.map((asset) => asset.alias));
    })();
  }

  return loadPromise;
}

export function getTexture(alias: string): Texture {
  return Assets.get<Texture>(alias);
}

const useLoader = () => {
  const [loaded, setLoaded] = useRecoilState(loaderState);

  async function loadAssets() {
    await loadAllAssets();
    setLoaded(true);
  }

  return {
    loaded,
    loadAssets,
    getTexture,
  };
};

export default useLoader;
